import { Plugin } from 'ckeditor5/src/core';
import DAMPluginUI from './dampluginui';
import { env } from '../env';

/**
 * The main DAM Browser plugin that allows selecting images from Kepeek DAM.
 */
export default class DAMPlugin extends Plugin {
	/**
	 * @inheritDoc
	 */
	public static get pluginName() {
		return 'DAMPlugin' as const;
	}

	/**
	 * @inheritDoc
	 */
	public static get requires() {
		return [ DAMPluginUI ] as const;
	}

	/**
	 * @inheritDoc
	 */
	public init(): void {
		const baseUrl = env.KEEPEEK_FRONTEND_BASE_URL || '';
		console.log( '🚀 ~ DAMPlugin ~ init ~ baseUrl:', baseUrl );

		const keepeekConfig = {
			baseUrl,
			jsLink: `${ baseUrl }/static/js/main.js`,
			cssLink: `${ baseUrl }/static/css/main.css`
		};

		this.editor.config.set( 'keepeek', keepeekConfig );

		this.editor.on( 'damImageSelected', ( evt, data ) => {
			if ( data && data.url ) {
				this.editor.execute( 'insertImage', { source: data.url } );
			}
		} );

		console.log( 'DAMPlugin initialized with Keepeek config:', keepeekConfig );
	}
}
